/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useDispatch } from "react-redux";
import { StoreDispatch } from "../store";

export const useStoreDispatch: () => StoreDispatch = useDispatch;
